module.exports = __webpack_public_path__ + "img/c7c7866.png";